// src/info.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import styled from 'styled-components';
import Navbar from '../components/Navbar';
import GlobalStyle from '../GlobalStyles';
import Footer from '../components/Footer';
import InfoBanner from '../components/InfoBanner';
import InfoCardNews from '../components/InfoCardNews';
import InfoCardActivities from '../components/InfoCardActivities';
import InfoAnnouncement from '../components/InfoAnnouncement';
import InfoCowork from '../components/InfoCowork';


const Container = styled.div`
  max-width: 100%;
  margin:0px;
  padding: 0px;
  background-color:#000000;
`;


function info() {



  return (

    <Container>
   
        <Navbar />
        <InfoBanner /> 
        <div id="news" ></div>
        <InfoCardNews /> 
        <div id="activities" ></div>
        <InfoCardActivities />
        <div id="announcement" ></div>
        <InfoAnnouncement  />
        <div id="cowork" ></div>
        <InfoCowork />

        <Footer /> 

    </Container>

  );
}

export default info;